var map = {
	"./img-restaurant-card-103.png": 778,
	"./img-restaurant-card-104.png": 5445,
	"./img-restaurant-card-155.png": 4263,
	"./img-restaurant-card-5.png": 4133,
	"./img-restaurant-card-6.png": 7406,
	"./img-restaurant-card-7.png": 3191,
	"./img-restaurant-card-8.png": 8960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4247;